import { Directive } from '@angular/core';
import {
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { GymUtils } from 'src/app/util/gym-util';

function urlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const isValid = GymUtils.isValidHomePageURL(control.value);
    return !isValid ? { invalidUrl: { value: control.value } } : null;
  };
}

@Directive({
  selector: '[gymfinderUrlValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: UrlValidatorDirective, multi: true },
  ],
  standalone: false,
})
export class UrlValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return urlValidator()(control);
  }
}
